import {HttpsUrl} from "../tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";

const debug = initDebugger('nettleser')

/** Åpner angitt URL i nytt nettleservindu.
 * MERK:  null is returned if the browser fails to open the new browsing context,
 * for example because it was blocked by a browser popup blocker. */
export function åpneINyttvindu(url: HttpsUrl, target = '_blank'): WindowProxy | null {
    debug(`åpneINyttvindu url:'${url}'`);
    return window.open(url, target);
}
